import SharedToolbar from '../../../shared/shared-toolbar-latest';
import {
  DirectoryRoles,
  isAbleToSeeUIElement,
} from '../../../utils/roles/client-roles';
import { useQueryClient } from '@tanstack/react-query';
import { UserKeys } from '../../../api/users-api';
import { Messages } from '../../../utils/message-constants';
import { Dispatch, SetStateAction } from 'react';
import SharedGridStateIconButton from '../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../shared/analytics/module-list';
import CreateButton from '../../../shared/buttons/create-button';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';
import { useNavigate } from 'react-router-dom';
import { pagesConfig } from '../../../shared/pages-config';
import { useUserSettings } from '../../../utils/use-user-settings';
import { isFeatureEnabled } from '../../../utils/feature-flags';

type GroupTemplatesGridToolbarProps = {
  directoryRoles: string[];
  setOpenCreateTemplate: Dispatch<SetStateAction<boolean>>;
  setOpenDeleteTemplates: Dispatch<SetStateAction<boolean>>;
  selectedRows: string[];
};

export function GroupTemplatesGridToolbar({
  directoryRoles,
  setOpenCreateTemplate,
  setOpenDeleteTemplates,
  selectedRows,
}: GroupTemplatesGridToolbarProps) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { features } = useUserSettings();
  const isGroupsGovernanceEnabled = isFeatureEnabled(
    'groupsGovernanceBackend',
    features
  );

  return (
    <SharedToolbar
      primaryButtons={
        <CreateButton
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.CreateGroupTemplate.value
            )
          }
          onClick={() => {
            if (isGroupsGovernanceEnabled) {
              navigate(
                `/${pagesConfig.groupTemplates.link}/${pagesConfig.createGroupTemplate.link}`
              );
              return;
            }
            setOpenCreateTemplate(true);
          }}
          label="Add Group Template"
        />
      }
      secondaryButtons={
        <>
          <SharedIconButton
            variant="delete"
            onClick={() => setOpenDeleteTemplates(true)}
            disabled={
              selectedRows.length === 0 ||
              !isAbleToSeeUIElement(
                directoryRoles,
                DirectoryRoles.DeleteGroupTemplates.value
              )
            }
            tooltipLabel={
              !isAbleToSeeUIElement(
                directoryRoles,
                DirectoryRoles.DeleteGroupTemplates.value
              )
                ? Messages.Errors.Permission.Acting(
                    DirectoryRoles.DeleteGroupTemplates.name
                  )
                : 'Delete'
            }
          />

          <SharedIconButton
            variant="refresh"
            onClick={() => {
              queryClient.invalidateQueries({
                queryKey: [UserKeys.GroupTemplates],
              });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="groupTemplatesGridStates"
            module={ModuleList.modules.directory.name}
            section={ModuleList.modules.directory.sections.groupTemplates}
          />
        </>
      }
    />
  );
}
